import axios from 'utils/axios'

export enum AuthorizationStatus {
  OK = 'ok',
  Unauthorized = 'unauthorized',
  VerifyOtp = 'verify_otp',
  MfaChallenge = 'mfa_challenge'
}

export interface LoginParams {
  email: string
  password: string
  remember_me: boolean
  recaptcha_token?: string
}

export interface VerifyOtpParams {
  email: string
  mfaCode: string
  session: string
  challengeName: string
  recaptcha_token?: string
}

export interface LoginResponse {
  status: AuthorizationStatus
  accessToken?: string
  refreshToken?: string
  expiresAt?: number
  session?: string
  challengeName?: string
}

export interface VerifyOtpResponse {
  status: AuthorizationStatus
  accessToken?: string
  refreshToken?: string
  expiresAt?: number
}

export async function login(params: LoginParams): Promise<LoginResponse> {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { recaptcha_token, remember_me: _remember_me, ...credentials } = params

  const response = await axios.post('/auth/login', {
    ...credentials,
    recaptcha_token
  })

  const data = response.data
  if (data.challengeName) {
    return {
      status: AuthorizationStatus.MfaChallenge,
      session: data.session,
      challengeName: data.challengeName
    }
  }

  return {
    status: AuthorizationStatus.OK,
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    expiresAt: data.expiresAt
  }
}

export async function verifyOtp(
  params: VerifyOtpParams
): Promise<VerifyOtpResponse> {
  const { recaptcha_token, ...rest } = params

  const response = await axios.post('/auth/respond-to-mfa', {
    ...rest,
    recaptcha_token
  })

  const data = response.data
  return {
    status: AuthorizationStatus.OK,
    accessToken: data.accessToken,
    refreshToken: data.refreshToken,
    expiresAt: data.expiresAt
  }
}

export async function logout(): Promise<null> {
  const response = await axios.post('/auth/logout')

  return response.data
}
